class SliderPress extends HTMLElement {
  constructor() {
    super();

    this.mainSliderElement = this.querySelector("[data-slider-main]");
    this.thumbsSliderElement = this.querySelector("[data-slider-thumbs]");
    this.thumbsSlidesCount = Number(
      this.thumbsSliderElement?.dataset?.slidesCount || 0
    );

    if (this.mainSliderElement && this.thumbsSliderElement) {
      this.mainSlider = new Swiper(this.mainSliderElement, {
        slidesPerView: 1,
        autoplay: {
          delay: 8000,
        },
        on: {
          slideChange: () => this.syncThumbsWithMain(),
        },
      });

      this.thumbsSlider = new Swiper(this.thumbsSliderElement, {
        slidesPerView: this.thumbsSlidesCount >= 3 ? 3 : this.thumbsSlidesCount,
        spaceBetween: 10,
        breakpoints: {
          990: {
            slidesPerView: this.thumbsSlidesCount >= 2 ? 2 : this.thumbsSlidesCount,
            spaceBetween: 0,
          }
        },
        on: {
          slideChange: () => this.syncMainWithThumbs(),
        },
      });
    }
  }

  syncThumbsWithMain() {
    const activeIndex = this.mainSlider.activeIndex;
    this.thumbsSlider.slideTo(activeIndex);
    this.updateActiveThumb(activeIndex);
  }

  syncMainWithThumbs() {
    const activeIndex = this.thumbsSlider.activeIndex;
    this.mainSlider.slideTo(activeIndex);
  }

  updateActiveThumb(activeIndex) {
    const thumbsSlides = this.thumbsSlider.slides;
    thumbsSlides.forEach(slide => slide.classList.remove('swiper-slide-active'));
    thumbsSlides[activeIndex].classList.add('swiper-slide-active');
  }
}

customElements.define("slider-press", SliderPress);
